module.exports = __webpack_public_path__ + "static/text-4-2acacd8ad23b45bae4a134163cb96216.svg";